<template>
    <div class="content-wrapper">
        <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <h1 class="m-0 text-dark">Pre-Registration</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-9">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">{{ stepHeader[step] }}</h3>
                        </div>
                        <div class="card-body">
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" :style="{ width: `${bar[step]}%` }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{bar[step]}} %</div>
                            </div>
                            <hr />
                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                                <a target="#err0" hidden id="err"></a>
                                <div class="alert-body">
                                    <p v-if="error_message && errors.length == 0" class="mb-0">
                                        {{ error_message }}
                                    </p>
                                    <div v-for="(v, k) in errors" :key="k">
                                        <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Step1 v-if="step==1" @next="onNext" @error="onError" />
                                <Step2 v-if="step==2" @next="onNext" @error="onError" />
                                <Step3 v-if="step==3" @next="onNext" @error="onError" />
                                <Step4 v-if="step==4" @next="onNext" @error="onError" />
                                <Step5 v-if="step==5" @next="onNext" @error="onError" :borrower_id="prereg.borrower_id" :completed="prereg.completed" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Step1 from "./forms/Step1.vue";
    import Step2 from "./forms/Step2.vue";
    import Step3 from "./forms/Step3.vue";
    import Step4 from "./forms/Step4.vue";
    import Step5 from "./forms/Step5.vue";
    export default {
        components: {
            Step1,
            Step2,
            Step3,
            Step4,
            Step5,
        },
        data() {
            return {
                error: 0,
                error_message: '',
                errors: [],
                loader: 0,
                prereg: {},
                step: 0,
                user: {},
                bar: [0, 20, 40, 60, 80, 100],
                stepHeader: [
                    '',
                    `Tell us something about your yourself`,
                    `Tell us where you are currently residing`,
                    `You're only a few steps away of completing your new account`,
                    `Upload or capture a photo of yourself holding the government-issued ID that you uploaded in the previous step`,
                    `Completed`,
                ],
            };
        },
        computed: {
            processingAPI() {
                return this.loader > 0;
            },
        },
        created() {
            this.getPrereg();

        },
        mounted() {
            Fire.$on('loader', this.onLoad);
        },
        methods: {
            resetError() {
                this.errors = [];
                this.error_message = '';
                this.error = 0;
            },
            onError(err) {
                this.error = 1;
                if (err.response.status == 500) {
                    this.error_message = 'Transaction Failed';
                } else {
                    if (err.response && err.response.data) {
                        this.errors = err.response.data.errors || [];
                        this.error_message = err.response.data.message;
                    } else {
                        this.error_message = err.message
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            },

            onLoad(x) {
                this.loader += x;
            },
            isEmptyObject(obj) {
                return Object.keys(obj).length === 0;
            },
            getPrereg() {
                this.loader++;
                axios
                    .get("/api/sblaf-prereg")
                    .then(res => {
                        this.loader--;
                        const data = res.data;
                        if (_.isEmpty(data)) {
                            this.step = 1;
                        } else {
                            this.prereg = res.data;
                            this.step = res.data.step;
                            if (res.data.completed == 1) {
                                this.$router.push('/dashboard');
                            }
                        }
                    })
                    .catch(err => {
                        this.loader--;
                        console.log(err);
                    });
            },
            onNext(s, c = 0) {
                this.resetError();
                Fire.$emit('loader', 1)
                axios
                    .post("/api/sblaf-prereg-update-step", {
                        step: s,
                        completed: c,
                    })
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.prereg = res.data;
                        this.step = res.data.step;
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        console.log(err);
                    });
            },
        },
    };
</script>
<style>
    .alert-info2 {
        color: #31708f !important;
        background-color: #d9edf7 !important;
        border-color: #bce8f1 !important;
    }

    .fc-red {
        color: red;
    }

    .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
    }

    label {
        font-size: 15px !important;
        font-weight: 500 !important;
    }

    .not-allowed {
        cursor: not-allowed;
    }

    .file-disabled {
        opacity: 0.65 !important;
        box-shadow: none;
        cursor: not-allowed !important;
        pointer-events: none !important;
    }

    .container-iframe {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0;
    }
</style>